import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=5b4397dc&"
import script from "./CookiePolicy.vue?vue&type=script&lang=ts&"
export * from "./CookiePolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports